var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",class:{'border':_vm.showBorder}},[_c('div',{staticClass:"left"},[_vm._t("default")],2),_c('div',{staticClass:"right"},[_vm._t("right"),(_vm.isLink)?_c('span',{staticClass:"iconfont arrow"},[_vm._v("")]):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }